import { EXPRESS_API } from 'configs/api/expressApi';
import { errorToast } from 'lib/components/toasts/error';
import { successToast } from 'lib/components/toasts/success';
import { useMutation, useQueryClient } from 'react-query';
import { guidesKeyes } from './guidesKeyes';
import { Links } from './guidesQuery';
import { useTranslation } from 'react-i18next';

export interface GuideUploadProps {
  guideCategoryId: number | null;
  name: string;
  videoId: number | string;
  description: string | null;
  videoSource: string;
  links: Links[];
  playerBackgroundColor: string;
  playButtonPosition: string;
  playerIconsAndTextColor: string;
}

type UploadedGuide = {
  userId: number;
  customerId: number;
  videoId: number;
  videoSource: string;
  updatedAt: string;
  createdAt: string;
  name: string;
  description: string;
  links: Links[];
  playerBackgroundColor: string;
  playButtonPosition: string;
  playerIconsAndTextColor: string;
  guideCategoryId: number;
};

const createGuides = async (body: GuideUploadProps[]) => {
  const { data } = await EXPRESS_API.post(`guides/bulk`, { payload: body });
  return data;
};

export const useCreateGuides = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation((data: GuideUploadProps[]) => createGuides(data), {
    onError: () => {
      errorToast({
        title: t('An error occurred creating guides, please try again later!'),
      });
    },
    onSuccess: (res: UploadedGuide[]) => {
      successToast({
        title: t('You have successfully created a video guide!', {
          count: res.length,
        }),
      });
      queryClient.refetchQueries(guidesKeyes.categorized());
      queryClient.invalidateQueries(guidesKeyes.new_count());
    },
  });
};
